(function ($) {
  Drupal.behaviors.socialShare = {
    attach: function (context, settings) {
      var url = document.documentURI;
      var title = artist_name = img = subjectLine = '';
      var socialShareContainer = $('.eh-social-share', context);

      if ($('#index-page-wrapper #page-headline').text().length) {
        title = $('#index-page-wrapper #page-headline').text();
        img = $('#index-page-wrapper .clinique_index_share_image').text();
        subjectLine = $.trim(title);
      } else {
        title = $('.eh-article-formatter .article-title').text();
        artist_name = $('.basic-elc-nodeblock-noderef .eh-carousel.hero-carousel > h3').text();
        img = $('.eh-article-formatter ul.slides > li .eh_hero_article_images img:eq(0)').attr('src');
        subjectLine = $.trim(title) + ': ' + $.trim(artist_name);
      }

      socialShareContainer.find('.social_icons:last').addClass('last-icon');

      var bodyText = Drupal.settings.ArticleDetailPage.translate_text.eh_email_text + ' %0D%0A %0D%0A' + subjectLine + '%0D%0A' + encodeURI(url);
      var shareText = title + ' ' + artist_name + ' ' + Drupal.settings.ArticleDetailPage.translate_text.eh_share_text;
      var email = 'mailto:?to=%20&body=' + bodyText + '&subject=' + encodeURI(subjectLine);
      var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&amp;text=' + encodeURI(shareText);
      var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&amp;t=' + encodeURI(shareText);
      var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&amp;media=' + encodeURI(window.location.protocol) + '//' +
              encodeURI(window.location.host) + img + '&amp;description=' + title + artist_name;
      // FE-1235: Build the Weibo social sharing URL
      var weibo_url = 'http://service.weibo.com/share/share.php?language=zh_cn&url=' + encodeURI(url) + '&amp;t=' + encodeURI(shareText);

      /* To store the Share Popup data's */
      socialShareContainer.find('.article .title').append(title);
      socialShareContainer.find('.article .artist_name').append(artist_name);
      socialShareContainer.find('.article .artist_img').attr('src', img);
      socialShareContainer.find('.social_share_links .mail a').attr('href', email);
      socialShareContainer.find('.social_share_links .facebook a').attr('href', facebook_url);
      socialShareContainer.find('.social_share_links .twitter a').attr('href', twitter_url);
      socialShareContainer.find('.social_share_links .pinterest a').attr('href', pinterest_url);
      // FE-1235: Add the Weibo social sharing URL
      socialShareContainer.find('.social_share_links .weibo a').attr('href', weibo_url);

      /* Share popup open */
      socialShareContainer.find('.share').on('click', function() {
        if (socialShareContainer.hasClass('closed')) {
          socialShareContainer.removeClass('closed', 400);
          socialShareContainer.find('.share').text(settings.ArticleDetailPage.translate_text.eh_share_close);
        } else if (socialShareContainer.hasClass('expanded')) {
          socialShareContainer.addClass('closed', 400);
          socialShareContainer.find('.share').text(settings.ArticleDetailPage.translate_text.eh_share);
        }
      });

      /* Social share links */
      $('.social_share_links .eh-social-share__link').on('click', function (e) {

        // Social share tagging for analytics start.
        var socialSplit = $(this).closest('.social_icons').attr('class');
        var eventLabel = socialSplit.split(' ');
        var analyticsVar = eventLabel[1];

        $(document).trigger('SocialShareIcon', analyticsVar);
        // Social share tagging for analytics end.

        if (!e) {
          var e = window.event;
        }
        e.cancelBubble = true;
        if (e.stopPropagation) {
          e.stopPropagation();
        }

        var width = 600;
        var height = 350;
        var openUrl = $(this).attr('href');
        // Allow for borders.
        var leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
        // Allow for title and status bars.
        var topPosition = (window.screen.height / 2) - ((height / 2) + 50);
        var windowFeatures = 'status=no,height=' + height + ',width=' + width;

        windowFeatures += ',resizable=yes,left=' + leftPosition + ',top=' + topPosition;
        windowFeatures += ',screenX=' + leftPosition + ',screenY=' + topPosition;
        windowFeatures += ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no';

        /*
        // Specifically for the Quickshop on MPP, find and use the media URL for Pinterest sharing
        if ($(this).hasClass('js-share--pinterest') && $(this).parents('.js-quickshop-container').length) {
          openUrl += '&media=' + turnRelativeToAbsolute($(this).parents('.js-quickshop-container').find('.js-gallery-img-large').attr('src'));
        }
        */

        if ($(this).parent().hasClass('mail')) {
          window.location.href = openUrl;
        } else {
          var newWin = window.open(openUrl, 'sharer', windowFeatures);
        }
        e.preventDefault();
      });
    }
  };
})(jQuery);